// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu10/Item.css
// module id = 2028
// module chunks = 0